import React, { useState } from "react";
import {
  FaCog,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaTimes,
  FaBars,
  FaGithub,
} from "react-icons/fa";
import "./FloatingActionButton.scss";
import { SiTryhackme } from "react-icons/si";

const FloatingActionButton = () => {
  const [expanded, setExpanded] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  // Close popup when clicking outside
  const handleOverlayClick = () => setSettingsOpen(false);

  const handleMainClick = () => {
    setExpanded((prev) => !prev);
    setSettingsOpen(false);
  };

  const handleCogClick = (e) => {
    e.stopPropagation();
    setSettingsOpen(true);
    setExpanded(false);
  };

  const fontOptions = [
    { label: "Sans", value: "'Segoe UI', Arial, sans-serif" },
    { label: "DM Sans", value: "'DM Sans', Arial, sans-serif" },
    { label: "Serif", value: "'Times New Roman', Times, serif" },
    { label: "Noto Serif", value: "'Noto Serif', Times, serif" },
    { label: "Monospace", value: "'Fira Mono', 'Courier New', monospace" },
    {
      label: "IBM Plex Mono",
      value: "'IBM Plex Mono', 'Fira Mono', 'Courier New', monospace",
    },
    {
      label: "Consolas",
      value: "Consolas, 'Fira Mono', 'Courier New', monospace",
    },
  ];

  const [font, setFont] = useState(fontOptions[0].value);
  const [secondaryColor, setSecondaryColor] = useState(
    getComputedStyle(document.documentElement).getPropertyValue(
      "--secondary-color"
    ) || "#007bff"
  );

  // Update font family
  const handleFontChange = (e) => {
    setFont(e.target.value);
    document.documentElement.style.setProperty("--font-base", e.target.value);
  };

  // Update secondary color
  const handleColorChange = (e) => {
    setSecondaryColor(e.target.value);
    document.documentElement.style.setProperty(
      "--secondary-color",
      e.target.value
    );
  };

  return (
    <>
      {expanded && !settingsOpen && (
        <div className="fab-overlay" onClick={() => setExpanded(false)} />
      )}
      <div className={`fab-group${expanded ? " expanded" : ""}`}>
        <button
          className={`floating-action-btn${expanded ? " open" : ""}`}
          onClick={handleMainClick}
          aria-label="Open actions"
        >
          {expanded ? <FaTimes /> : <FaBars />}
        </button>
        {expanded && (
          <div className="fab-actions">
            <a
              href="https://tryhackme.com/p/diliabdel"
              target="_blank"
              rel="noopener noreferrer"
              className="fab-action-btn"
              aria-label="Tryhackme"
            >
              <SiTryhackme />
            </a>
            <a
              href="https://github.com/momonaim"
              target="_blank"
              rel="noopener noreferrer"
              className="fab-action-btn"
              aria-label="Github"
            >
              <FaGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/abdelmounim-mouadili-6bb946283"
              target="_blank"
              rel="noopener noreferrer"
              className="fab-action-btn"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
            <button
              className="fab-action-btn"
              onClick={handleCogClick}
              aria-label="Settings"
            >
              <FaCog />
            </button>
          </div>
        )}
      </div>
      {settingsOpen && (
        <>
          <div className="fab-overlay" onClick={handleOverlayClick} />
          <div className="fab-popup">
            <h4>Settings</h4>
            <ul>
              <li>
                <label htmlFor="font-select">Font:</label>
                <select
                  id="font-select"
                  value={font}
                  onChange={handleFontChange}
                >
                  {fontOptions.map((opt) => (
                    <option value={opt.value} key={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </li>
              <li>
                <label htmlFor="color-input">Secondary Color:</label>
                <input
                  id="color-input"
                  type="color"
                  value={secondaryColor.trim()}
                  onChange={handleColorChange}
                  style={{ marginLeft: 8, verticalAlign: "middle" }}
                />
              </li>
              <li>Chat: (coming soon)</li>
              {/* Add more features here */}
            </ul>
          </div>
        </>
      )}
    </>
  );
};

export default FloatingActionButton;
